import React, { Suspense, lazy, useEffect } from 'react'; 
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
// 🚀 Smart Imports
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { Navbar, BottomNav } from './components'; 
import LandingPage from './components/LandingPage'; 
import LoginPage from './components/LoginPage';

const Feed = lazy(() => import('./components/Feed'));
const SubscriptionPage = lazy(() => import('./components/SubscriptionPage'));
const Shorts = lazy(() => import('./components/Shorts'));
const VideoDetail = lazy(() => import('./components/VideoDetail'));
const ChannelDetail = lazy(() => import('./components/ChannelDetail'));
const SearchFeed = lazy(() => import('./components/SearchFeed'));

const AppContent = () => {
  const location = useLocation();
  const isLoggedIn = localStorage.getItem('userLoggedIn') === 'true';
  const isAuthPage = location.pathname === '/' || location.pathname === '/login';

  // 🎵 BACKGROUND PLAY & DEEP LINKING LOGIC
  useEffect(() => {
    // 1. Connection Speed Detection (Aapka purana logic)
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && (conn.saveData || ['slow-2g', '2g', '3g'].includes(conn.effectiveType))) {
        console.log("Slow connection detected. Optimizing resources...");
    }

    // 2. Background Mode Setup (Naya Logic)
    if (window.cordova && window.cordova.plugins && window.cordova.plugins.backgroundMode) {
      const bg = window.cordova.plugins.backgroundMode;
      bg.enable(); // Background mode chalu karein
      bg.overrideBackButton(); // Back button se app kill na ho
      
      bg.setDefaults({
        title: 'YouTube Clone',
        text: 'वीडियो बैकग्राउंड में चल रहा है',
        icon: 'icon', 
        color: 'F14336',
        resume: true,
        hidden: false
      });

      // WebView optimizations ko disable karna taaki video/audio chalta rahe
      bg.on('activate', () => {
        bg.disableWebViewOptimizations();
      });
    }
  }, []);

  return (
    <Box sx={{ backgroundColor: '#000', minHeight: '100vh', color: 'white' }}>
      {!isAuthPage && <Navbar />}
      
      <Suspense fallback={
        <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
          <CircularProgress sx={{ color: '#FF1100' }} />
        </Box>
      }>
        <Routes>
          <Route exact path='/' element={isLoggedIn ? <Navigate to="/feed" /> : <LandingPage />} />
          <Route path='/login' element={isLoggedIn ? <Navigate to="/feed" /> : <LoginPage />} />
          
          <Route path='/feed' element={<Feed />} />
          <Route path='/subscriptions' element={<SubscriptionPage />} />
          <Route path='/shorts' element={<Shorts />} />
          <Route path='/video/:id' element={<VideoDetail />} />
          <Route path='/channel/:id' element={<ChannelDetail />} />
          <Route path='/search/:searchTerm' element={<SearchFeed />} />
        </Routes>
      </Suspense>

      {!isAuthPage && <BottomNav />}
    </Box>
  );
};

const App = () => (
  <BrowserRouter>
    <AppContent />
  </BrowserRouter>
);

export default App;
